var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('th',[_c('panorama-header-item',{attrs:{"title":"Taux"}})],1),_c('th',[_c('panorama-header-item',{attrs:{"title":"Répartition"}})],1),_c('th',[_c('panorama-header-item',{attrs:{"title":"CSP"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }